import React from 'react';
import { TrendingUp, ShieldCheck, Clock } from 'lucide-react';
export function AboutSection() {
  const features = [{
    icon: TrendingUp,
    title: 'Operational Excellence',
    description: 'We implement modern management systems to optimize efficiency and improve customer experience.'
  }, {
    icon: ShieldCheck,
    title: 'Reliable Transition',
    description: 'Our experienced team ensures a smooth handover process, protecting your legacy and staff.'
  }, {
    icon: Clock,
    title: 'Immediate Liquidity',
    description: 'We provide fair valuations and quick closing timelines for owners looking to exit.'
  }];
  return <section id="about" className="py-16 sm:py-20 lg:py-24 bg-[#0b1a1a]" data-id="element-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="text-center max-w-3xl mx-auto mb-12 sm:mb-16" data-id="element-14">
          <h2 className="text-xs sm:text-sm font-semibold text-[#4fd1c5] tracking-widest uppercase mb-4 sm:mb-6" data-id="element-15">
            Our Differentiators
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8" data-id="element-16">
          {features.map((feature, index) => <div key={index} className="p-6 sm:p-8 rounded-2xl bg-[#0f2424] border border-gray-800 hover:border-[#4fd1c5]/30 transition-all duration-300 group" data-id="element-17">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-[#4fd1c5]/10 flex items-center justify-center mb-5 sm:mb-6 group-hover:bg-[#4fd1c5] transition-colors duration-300" data-id="element-18">
                <feature.icon className="h-5 w-5 sm:h-6 sm:w-6 text-[#4fd1c5] group-hover:text-[#0f2424] transition-colors" data-id="element-19" />
              </div>
              <h4 className="text-lg sm:text-xl font-bold text-white mb-3" data-id="element-20">
                {feature.title}
              </h4>
              <p className="text-sm sm:text-base text-gray-400 leading-relaxed" data-id="element-21">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}